










































/**
 * @author wangyingxu1
 * menu-nav
 */

import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { urlMap, isTextEnv, env } from '@/config';

@Component({})
export default class MenuNav extends Vue {
  @Prop({ type: Array, default: (): any[] => ([]) }) public authTree!: any[];

  public homeMenu: any = {
    id: 'home',
    menuCode: 'home',
    menuIcon: '',
    menuIndex: -999,
    menuName: '首页',
    menuType: 1,
    menuUrl: `${urlMap.logout}/resource`
  };
  public renderTree: any[] = [];
  public renderTreeMap: any = {};
  public defaultMenuIndex: string = '2-2';
  public currentMenuIndex: string = '';
  public openeds: any[] = []; // 默认展开
  public symbolEnv: string = '{env}';

  @Watch('authTree')
  public authTreeChange(): void {
    if (!this.authTree.length) {
      return;
    }
    const renderTree: any[] = this.dealAuthTree([ this.homeMenu, ...this.authTree ]);
    const newArr: any = [];
    renderTree.forEach((item: any, index: number) => {
      newArr[index] = item;
      newArr[index].children = item.children.filter((item2: { menuType: number; }) => item2.menuType !== 3);
    });
    this.setCurrentMenuIndex();

    const openeds: any[] = [];
    renderTree.forEach((item: any): void => {
      if (item.children && item.children.length) {
        openeds.push(item.level);
      }
    });
    this.openeds = openeds;
    this.renderTree = renderTree;
  }

  public symbolUrlToUrl(symbolUrl: string): string {
    let url: string = '';
    if (!symbolUrl) {
      return url;
    }
    url = symbolUrl;
    if (url.indexOf('{env}') !== -1) {
      url = url.replace(this.symbolEnv, env);
    }
    return url;
  }

  public dealAuthTree(tree: any[], fatherLevel: string = ''): any[] {
    const renderTree: any[] = tree.sort((a: any, b: any): number => (+a.menuIndex || 0) - (+b.menuIndex || 0));
    return renderTree.map((item: any, index: number): any => {
      const level: string = fatherLevel ? `${fatherLevel}-${index}` : `${index}`;
      const children: any[] = (item.children && item.children.length) ? this.dealAuthTree(item.children, level) : [];
      const copyItem: any = { ...item };
      if (isTextEnv) { // 测试环境 替换url
        copyItem.menuUrl = this.symbolUrlToUrl(copyItem.menuUrl);
      }
      this.renderTreeMap[level] = copyItem;

      return {
        ...copyItem,
        children,
        level
      };
    });
  }

  public setCurrentMenuIndex(): void {
    const { hostname, pathname, hash } = window.location;
    let currentUrl: string = hostname;
    if (pathname && hash) { // 优先取 host + hash 定位导航
      currentUrl = `${hostname}${pathname}${hash.split('?')[0]}`;
      const hostPathHashCurrentLevel: string | undefined =
        Object.keys(this.renderTreeMap).find((level: string): boolean => {
          const menuItem: any = this.renderTreeMap[level];
          return menuItem.menuUrl && (menuItem.menuUrl.indexOf(currentUrl) !== -1);
        });
      if (hostPathHashCurrentLevel) {
        this.defaultMenuIndex = hostPathHashCurrentLevel;
        this.currentMenuIndex = hostPathHashCurrentLevel;
        return;
      }
    }

    if (pathname && pathname !== '/') { // 取 host + path 定位导航
      currentUrl = (pathname && pathname !== '/') ? `${hostname}${pathname}` : hostname;
      const hostPathCurrentLevel: string | undefined =
        Object.keys(this.renderTreeMap).find((level: string): boolean => {
          const menuItem: any = this.renderTreeMap[level];
          return menuItem.menuUrl && (menuItem.menuUrl.indexOf(currentUrl) !== -1);
        });
      if (hostPathCurrentLevel) {
        this.defaultMenuIndex = hostPathCurrentLevel;
        this.currentMenuIndex = hostPathCurrentLevel;
        return;
      }
    }

    // host + path 没有找到对应的导航 用host
    const hostCurrentLevel: string | undefined =
      Object.keys(this.renderTreeMap).find((level: string): boolean => {
        const menuItem: any = this.renderTreeMap[level];
        return menuItem.menuUrl && (menuItem.menuUrl.indexOf(hostname) !== -1);
      });
    if (hostCurrentLevel) {
      this.defaultMenuIndex = hostCurrentLevel;
      this.currentMenuIndex = hostCurrentLevel;
      return;
    }
  }

  public handleSelect(index: string): void {
    if (!this.renderTreeMap[index] || !this.renderTreeMap[index].menuUrl) {
      return;
    }
    if (this.currentMenuIndex === index) {
      return;
    }
    window.location.href = this.renderTreeMap[index].menuUrl;
    // setTimeout解决切换地址如果是hash值切换，页面不刷新的问题
    // 如果切换地址不是hash，页面通过window.location.href正常重新加载，下面的setTimeout会被销毁，不会二次刷新
    setTimeout(() => { window.location.reload(); }, 200);
  }
}

